//
import ItemModel from '@/models/Warehouse/WhItem'

/**
 *
 */
const createItem = async ( data ) => {
    //
    try {
        //
        const response = await ( new ItemModel( data ) ).save()
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default createItem
